import { fromFetch } from 'rxjs/fetch';
import { retryWhen, timeout, catchError } from 'rxjs/operators';
import { MAX_RESPONSE_TIME } from '_data/constants';
import { genericRetryStrategy, maxRetryAttempts } from '_helpers/rx';

const _fetch = (...params) =>
  fromFetch(...params)
    .pipe(
      timeout(MAX_RESPONSE_TIME),
      catchError(err => {
        if (err.name === 'TimeoutError') {
          const event = new Event('timeouted');
          document.dispatchEvent(event);
        }
        throw err;
      }),
      retryWhen(genericRetryStrategy({ maxRetryAttempts }))
    )
    .toPromise();

export default _fetch;
